import { z } from 'zod';
// --- Chat request schemas (per-request model override, DM #541) ---
//
// The BODY SHAPE only. The authorization rule lives in `constants/aiRequestModel.ts`
// and the transport gate in the api's `modules/ai/aiChatRequestBoundary.ts`, so REST
// `POST /api/ai/chat` and the WS `agent:chat` / `ai:chat` / `ai:continue` events parse
// the same fields with the same bounds.
/** A model id as a caller may write it. Bounded to the `ai_profiles.settings.model` column width. */
export const chatModelIdSchema = z.string().trim().min(1).max(100);
/**
 * Caller-supplied `profileId`, DECLARED so the model gate's two inputs are one shape.
 *
 * Never throws: anything that is not a positive integer becomes `undefined` — the REST
 * surface's long-standing discard (`chatHandler.profileAccess.test.ts` pins `'2'` → no
 * gate, no dispatch). Each transport keeps its own pinned id resolution downstream
 * (REST's numeric guard + `assertProfileAccess` 404 folding; the WS `normalizeProfileId`
 * arm), so this declaration does not move where the access decision is taken.
 */
const chatProfileIdSchema = z.preprocess((raw) => (typeof raw === 'number' && Number.isInteger(raw) && raw > 0 ? raw : undefined), z.number().int().positive().optional());
/**
 * The fields the model gate reads.
 *
 * Deliberately NOT `.strict()`: the chat surfaces accept transport-specific keys
 * (`conversationHistory`, `moduleContext`, `context`, `scopeId`, `conversationId`,
 * `attachments`) and external X-AI-Key consumers post shapes this package does not
 * enumerate (gh#1906). Undeclared keys are STRIPPED from the parse result; every handler
 * still reads its own fields off the raw body, exactly as before.
 */
export const chatModelOverrideFieldsSchema = z.object({
    profileId: chatProfileIdSchema,
    model: chatModelIdSchema.optional(),
});
/** The override fields plus the message a REST chat request must carry. */
export const chatRequestCoreSchema = chatModelOverrideFieldsSchema.extend({
    message: z.string().min(1),
});
//# sourceMappingURL=aiChat.schema.js.map